import { Schema } from "effect";

// Gmail-specific provider data
export const GmailProviderData = Schema.Struct({
  provider: Schema.Literal("gmail"),
  gmailMessageId: Schema.String,
  gmailThreadId: Schema.String,
  gmailHistoryId: Schema.NullOr(Schema.String),
});
export type GmailProviderData = typeof GmailProviderData.Type;
